export default [
  {
    path: "/store/street",
    name: "StoreStreet",
    meta: {
      title: "店铺街",
      keepAlive: true,
    },
    component: () => import("@views/store/Street")
  },
  {
    path: "/store/detail/:id",
    name: "StoreDetail",
    meta: {
      title: "店铺详情",
      keepAlive: false,
    },
    component: () => import("@views/store/Detail")
  },
]
